<div class="epsg-code-tips-wrapper">

  <div class="title_close">
    <h2>{{ 'sources.espgCodeTips.Title' | translate }}</h2>
    <button [mat-dialog-close]="false" class="close" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content">
    <ol>
      <li>
        <span>{{ 'sources.espgCodeTips.Tip1FirstPart' | translate }} <a href="https://epsg.io">epsg.io</a>
          {{ 'sources.espgCodeTips.Tip1SecondPart' | translate }}</span>

        <img class="epsg-io-image mat-elevation-z4" src="/assets/img/epsg-io.png" alt="epsg-code-tips-image-1">
      </li>

      <li>
        <span>{{ 'sources.espgCodeTips.Tip2' | translate }}</span>

        <img class="epsg-io-list-image mat-elevation-z4" src="/assets/img/epsg-io-list.png" alt="epsg-io-list">
      </li>

      <li>
        <span>{{ 'sources.espgCodeTips.Tip3' | translate }}</span>

        <img class="epsg-io-code-image mat-elevation-z4" src="/assets/img/epsg-io-code.png" alt="epsg-io-code">
      </li>
    </ol>
  </div>


</div>
